import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/mietUndWohnungseigentumsrecht.webp";

const data: AreaContent = {
  id: Area.MIETUNDWOHNUNGSEIGENTUMSRECHT,
  hero: hero,
  content: [
    "<strong>Wohnraummietrecht</strong>",
    "Die Wohnraummiete gehört speziell in Ballungsgebieten wie Berlin zu den häufigsten Wohnformen und spielt daher im Alltag eine große und wiederkehrende Rolle.",
    "Wir bieten Mieter:innen und Vermieter:innen insbesondere folgende Leistungen an:",
    [
      "Erstellung und Prüfung von Mietverträgen",
      "Beratung und Gestaltung von Kündigungen",
      "Abwehr und Erhebung von Räumungsklagen",
      "Beratung zu Räumungsvergleichen und Räumungsschutz",
      "Prüfung von Mietmängeln und Mietminderung",
      "Prüfung von Betriebs- und Heizkostenabrechnungen",
      "Beratung zu Instandsetzungs- und Modernisierungsmaßnahmen",
      "Prüfung von Mieterhöhungsverlangen",
      "Beratung bei Beendigung des Mietverhältnisses",
    ],

    "<strong>Gewerberaummietrecht und Pachtrecht</strong>",
    "Die Vermietung oder Verpachtung stellt sowohl für Vermieter:innen als auch für gewerbetreibende Mieter:innen meist eine wirtschaftliche Existenzgrundlage dar und ist somit auch von großer persönlicher Bedeutung.",
    "Wir bieten Vermieter:innen und Mieter:innen von Gewerbeeinheiten unter anderem folgende Leistungen an:",
    [
      "Beratung und Gestaltung von Gewerbemietverträgen und Pachtverträgen, insbesondere zu Nutzungszweck, Laufzeit, Verlängerungsoptionen, Herstellungs- und Umbauverpflichtungen, Versicherungspflicht, Konkurrenzschutz, Miethöhe, Mietstruktur und Mietanpassung, Mietsicherheit, Minderung und Aufrechnung sowie Instandhaltung und Instandsetzung",
      "Beratung während des Mietverhältnisses, insbesondere zu Abmahnung, Kündigung, Zahlung und Vertragsanpassung",
    ],

    "<strong>Wohnungseigentumsrecht</strong>",
    "Der Kauf einer Immobilie zur Eigennutzung oder Kapitalanlage bedarf zuvor einer gründlichen Prüfung, insbesondere hinsichtlich der Instandhaltung, möglicher Instandhaltungsrückstände, Eigentümerbeschlüsse sowie Eigentums- und Nutzungsverhältnisse.",
    "Wir unterstützen Sie daher nicht nur beim Kauf einer bereits errichteten Immobilie, sondern auch bei Bauträgerobjekten und Neubauten und begleiten Sie vom Kaufvertragsabschluss bis zur Wohnungseigentümerversammlung.",
    "Wir bieten Wohnungseigentümer:innen und Wohnungseigentümergemeinschaften vor allem folgende Leistungen an:",
    [
      "Beratung bei Kauf oder Verkauf einer Immobilie, auch hinsichtlich der Abgrenzung von Gemeinschafts- und Sondereigentum und der Einräumung von Sondernutzungsrechten",
      "Prüfung der Teilungserklärung",
      "Unterstützung bei der Wohnungseigentümerversammlung sowie Vorbereitung und Prüfung von Beschlüssen der WEG",
      "gerichtliche Vertretung in Beschlussanfechtungsverfahren, Beschlussersetzungsklagen, Auflassungsklagen und Schadenersatzklagen",
    ],
  ],
  bullets: [
    "Vertragsgestaltung Wohnraummiete",
    "Gewerberaummiete",
    "Wohnungseigentum",
    "Bauträgervertrag",
    "WEG-Recht",
  ],
  more: [],
};

export default data;
